import { toast } from 'react-toastify';

export default function useAlert() {
  return ({ message, type = 'success' }) => {
    if (type === 'error') toast.error(message);
    else toast.success(message);
  };
}